import { defineMessages } from 'react-intl'

export default defineMessages({
  heroHeading: {
    id: 'GEPage.heroHeading',
    defaultMessage: 'Imagine half-price health!',
  },
  heroSubHeading: {
    id: 'GEPage.heroSubHeading',
    defaultMessage: 'Exclusive for GE',
  },
  ctaButtonText: {
    id: 'GEPage.ctaButtonText',
    defaultMessage: 'Claim deal',
  },
  introHeading: {
    id: 'GEPage.introHeading',
    defaultMessage:
      'All the tools, nutritional tips and tastes you need to succeed.',
  },
  introText: {
    id: 'GEPage.introText',
    defaultMessage:
      'Make 2019 your healthiest year ever! We are excited to offer all eligible GE employees an exclusive 50% discount on Lifesum Premium!',
  },
  callOut: {
    id: 'GEPage.callOut',
    defaultMessage: 'Claim your 50% off Premium deal now!',
  },
  howToHeading: {
    id: 'GEPage.howToHeading',
    defaultMessage: 'Here’s how Lifesum works',
  },
  whatsIncludedHeading: {
    id: 'GEPage.whatsIncludedHeading',
    defaultMessage: 'What’s included',
  },
  pricingInfo: {
    id: 'GEPage.pricingInfo',
    defaultMessage: '{price}/year – only {pricePerMonth} / month',
  },
  errorMessage: {
    id: 'Account.verifyError',
    defaultMessage:
      'Something went wrong, and it’s our fault. Sorry about that. If the problem persist, please contact us.',
  },
  tryAgain: {
    id: 'GEPage.tryAgain',
    defaultMessage: 'Try again',
  },
})
